/**
 * Get the current application environment
 * @returns The current environment (staging, local, production, etc.)
 */
export function getCurrentEnvironment(): string {
  const config = useRuntimeConfig()
  return (config.public.APP_ENV as string) || 'local'
}

/**
 * Check if the current environment should show the environment badge
 * @returns true if the badge should be shown (not production)
 */
export function shouldShowEnvironmentBadge(): boolean {
  const env = getCurrentEnvironment().toLowerCase()
  return env !== 'production'
}

/**
 * Get the environment badge text
 * @returns The formatted environment text for the badge
 */
export function getEnvironmentBadgeText(): string {
  return `${getCurrentEnvironment().toUpperCase()} ENVIRONMENT`
}
